module.exports = __webpack_public_path__ + "assets/b23445a3113a6f0abc1069b2a776d729.mp3";